<template>
  <div class="logo">
    <img :src="logoUrl" />
    <!-- <object type="image/svg+xml" data="images/logo.svg" class="logo">
    </object> -->
  </div>
</template>

<script>
import getDomain from "../../mixins/getDomain";

export default {
  name: "logo",
  mixins: [getDomain],
  computed: {
    logoUrl() {
      console.log(this.getDomain());
      if (this.getDomain() === "allefolders") {
        return "images/logo.png";
      } else if (this.getDomain() === "promopromo") {
        return "images/promopromo_logo.png";
      } else if (this.getDomain() === "myshopi") {
        return "images/myshopi_logo.png";
      } else {
        return "images/logo.png";
      }
    }
  }
};
</script>
